import type { SocialLinks } from "./socials.d";

const SOCIAL_LINKS: SocialLinks = {
  fallback: {
    facebook: {
      url: "https://www.facebook.com/AirHelp",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/theairhelper",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  cs: {
    facebook: {
      url: "https://www.facebook.com/AirHelp",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/theairhelper",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  da: {
    facebook: {
      url: "https://www.facebook.com/AirHelpDK/",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.dk",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/airhelpdk",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  de: {
    facebook: {
      url: "https://www.facebook.com/AirHelpDeutsch",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.de/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/airhelpde",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  "de-ch": {
    facebook: {
      url: "https://www.facebook.com/AirHelpDeutsch",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.de/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/airhelpde",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  "de-at": {
    facebook: {
      url: "https://www.facebook.com/AirHelpDeutsch",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.de/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/airhelpde",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  en: {
    facebook: {
      url: "https://www.facebook.com/AirHelp",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/theairhelper",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  es: {
    facebook: {
      url: "https://www.facebook.com/AirHelpES",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelp_ES",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  el: {
    facebook: {
      url: "https://www.facebook.com/AirHelpGR",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpEllada",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  fi: {
    facebook: {
      url: "https://www.facebook.com/AirHelpSuomi",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpSuomi",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  fr: {
    facebook: {
      url: "https://www.facebook.com/AirHelpFr",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpFrance",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  it: {
    facebook: {
      url: "https://www.facebook.com/AirHelpItalia",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpItalia",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  nl: {
    facebook: {
      url: "https://www.facebook.com/AirhelpNL",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.nl/",
      title: "Instagram AirHelp",
    },
    twitter: { url: "https://twitter.com/AirHelpNL", title: "Twitter AirHelp" },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  nb: {
    facebook: {
      url: "https://www.facebook.com/AirHelpNorge",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpNorge",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  pl: {
    facebook: {
      url: "https://www.facebook.com/AirHelpPL",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelp_Polska",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  "pt-br": {
    facebook: {
      url: "https://www.facebook.com/AirHelpBrasil",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp.br/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirHelpBrasil",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  "pt-pt": {
    facebook: {
      url: "https://www.facebook.com/AirHelpPT",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: { url: "https://twitter.com/AirHelpPT", title: "Twitter AirHelp" },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  ru: {
    facebook: {
      url: "https://www.facebook.com/RussiaAirHelp",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: { url: "https://twitter.com/AirHelpRU", title: "Twitter AirHelp" },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  ro: {
    facebook: {
      url: "https://www.facebook.com/AirHelpRO",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/AirhelpRomania",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  sv: {
    facebook: {
      url: "https://www.facebook.com/AirHelpSverige",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/theairhelper",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
  "zh-cn": {
    facebook: {
      url: "https://www.facebook.com/AirHelp",
      title: "Facebook AirHelp",
    },
    instagram: {
      url: "https://www.instagram.com/airhelp/",
      title: "Instagram AirHelp",
    },
    twitter: {
      url: "https://twitter.com/theairhelper",
      title: "Twitter AirHelp",
    },
    linkedin: {
      url: "https://www.linkedin.com/company/airhelp",
      title: "LinkedIn AirHelp",
    },
  },
};

export default SOCIAL_LINKS;
